export const StepperOrientation = {
    HORIZONTAL: "horizontal",
    VERTICAL: "vertical"
};
